import { axiosInstance } from "../apiConfig";

export const fetchMission3RookieData = async (systemName, authToken) => {
  try {
    const response = await axiosInstance.post(
      "/api/mission3/rookie/data",
      systemName,
      authToken
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.data.packetLog;
  } catch (error) {
    console.error("Error fetching rookie data:", error);
    throw error;
  }
};

export const submitMission3Rookie = async (
  systemName,
  authToken,
  coordinates
) => {
  try {
    const response = await axiosInstance.post("/api/mission3/rookie/submit", {
      systemName,
      authToken,
      coordinates,
    });
    // if (response.status !== 200) {
    //   throw new Error(`error: ${response.error}`);
    // }

    return response.data;
  } catch (error) {
    console.error("Error fetching rookie data:", error);
    // throw error;
  }
};

export const fetchMission3IntermediateData = async (systemName, authToken) => {
  try {
    const response = await axiosInstance.post(
      "/api/mission3/intermediate/data",
      systemName,
      authToken
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching intermediate data:", error);
    throw error;
  }
};

export const submitMission3Intermediate = async ({
  systemName,
  authToken,
  guesses,
}) => {
  try {
    const response = await axiosInstance.post(
      "/api/mission3/intermediate/submit",
      {
        systemName,
        authToken,
        guesses,
      }
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.data; // Expecting { matchedTimestamps: ["14:29", "14:30", ...] } or similar
  } catch (error) {
    console.error("Error checking coordinates:", error);
    throw error;
  }
};

export const fetchMission3AdvancedData = async (systemName, authToken) => {
  try {
    const response = await axiosInstance.post(
      "/api/mission3/advanced/data",
      systemName,
      authToken
    );

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching advanced data:", error);
    throw error;
  }
};

export const submitMission3Advanced = async ({
  systemName,
  authToken,
  guesses,
}) => {
  try {
    const response = await axiosInstance.post("/api/mission3/advanced/submit", {
      systemName,
      authToken,
      guesses,
    });

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.data; // Expecting { matchedTimestamps: ["14:29", "14:30", ...] } or similar
  } catch (error) {
    throw error;
  }
};
